import React from 'react';
import { IconButton, Tooltip, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { useFavorites } from '../context/FavoritesContext';

const FavoriteButton = ({
  interfaceName,
  interfacePath,
  category = 'others',
  size,                // optional — if omitted, we use a responsive size
  position = 'absolute',
  top,                 // optional — if omitted, we use a responsive top
  right,               // optional — if omitted, we use a responsive right
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const { isFavorite, toggleFavorite } = useFavorites();

  // Use provided path or current location path
  const path = interfacePath || location.pathname;
  const isCurrentFavorite = isFavorite(path);

  const handleToggle = (e) => {
    e.stopPropagation();
    toggleFavorite({
      path,
      name: interfaceName,
      category,
    });
  };

  // Responsive defaults — xs phones need the star tucked into the corner and out
  // of the way of breadcrumbs / headings / other buttons, but desktop keeps the
  // original 22/56 placement so nothing moves on larger screens.
  const topValue = top ?? { xs: 8, sm: 14, md: 22 };
  const rightValue = right ?? { xs: 8, sm: 14, md: 56 };
  // react-icons can't consume responsive sx values, so resolve a single size now.
  const iconSize = size ?? (isMobile ? 18 : 22);

  return (
    <Tooltip title={isCurrentFavorite ? 'Remove from favorites' : 'Add to favorites'}>
      <IconButton
        onClick={handleToggle}
        sx={{
          position,
          top: topValue,
          right: rightValue,
          zIndex: 2, // sit above breadcrumb / title
          padding: { xs: '4px', md: '8px' },
          color: isCurrentFavorite
            ? '#FFD700'
            : theme.palette.mode === 'light'
            ? '#1b2a41'
            : '#ffffff',
          transition: 'all 0.2s ease',
          '&:hover': {
            color: '#FFD700',
            transform: 'scale(1.1)',
          },
        }}
      >
        {isCurrentFavorite ? <FaStar size={iconSize} /> : <FaRegStar size={iconSize} />}
      </IconButton>
    </Tooltip>
  );
};

export default FavoriteButton;
